var PreLoginApi = async (API_END_POINT = "", REQUEST_BODY = "", IS_FILE=0) => {
    let arr = { status: 0 };

    try {

        let headerArr = {
            'Accept': 'application/json',
            'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE'
        };

        if(IS_FILE === 0) {
            headerArr["Content-Type"] = "application/json";
        }


        await fetch(process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_API_PREFIX + API_END_POINT, {
            method: 'POST',
            headers: new Headers(headerArr),
            body: REQUEST_BODY
        })
            .then(res => res.json())
            .then((result) => {
                arr['status'] = 1;
                arr['data'] = result;
            }, (error) => {
                arr['data'] = error;
            }
            );
    }
    catch (err) {
        arr['data'] = err;
    }
    finally {
        return arr;
    }
}

export default PreLoginApi;